import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { Transaction, TransactionSelectionProps } from "../types/TransactionTypes";
import { getProductName } from "@/components/history/ProductUtils";

interface TransactionListProps extends TransactionSelectionProps {
  transactions: Transaction[];
}

export const TransactionList = ({
  transactions,
  showCheckbox,
  onTransactionSelect,
  selectedTransactions = new Set(),
}: TransactionListProps) => {
  return (
    <div className="space-y-2 text-sm">
      {transactions.map((transaction) => (
        <div key={transaction.id} className="border-b pb-2">
          <div className="flex items-center justify-between">
            {showCheckbox && onTransactionSelect && (
              <Checkbox
                id={`transaction-${transaction.id}`}
                checked={selectedTransactions.has(transaction.id)}
                onCheckedChange={(checked) =>
                  onTransactionSelect(transaction.id, checked === true)
                }
                className="mr-2"
              />
            )}
            <span className="text-gray-600">
              {format(new Date(transaction.date), "dd MMMM yyyy HH:mm", {
                locale: fr,
              })}
            </span>
            <div className="flex items-center gap-2">
              <span className="font-medium">
                {transaction.amount.toLocaleString()} FCFA
                {transaction.type === "credit_sale" && " (payé)"}
              </span>
            </div>
          </div>
          <div className="text-gray-500">
            {transaction.stock_items && (
              <div className="mb-1">
                {getProductName(transaction.stock_items)}
              </div>
            )}
            {transaction.notes}
            {transaction.remainingAmount && transaction.remainingAmount > 0 && (
              <div className="text-orange-500 mt-1">
                Reste à payer: {transaction.remainingAmount.toLocaleString()} FCFA
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};